import { t } from "@lingui/macro";
import { useAtomValue } from "jotai";

import { Crementor } from "@whoosh/design-system/src/components/controls/Crementor";
import { Avatar } from "@whoosh/design-system/src/components/display";
import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

import { currentBookingAtom } from "../../../../atoms/stores";

type Props = {
  onAddUnknownGuest: () => void;
  onRemoveUnknownGuest: () => void;
  capacityOnBooking: number;
  membersCanAddUnknownGuests: boolean;
};

export const UnknownGuestCounter = ({
  onAddUnknownGuest,
  onRemoveUnknownGuest,
  capacityOnBooking,
  membersCanAddUnknownGuests,
}: Props) => {
  const currentBooking = useAtomValue(currentBookingAtom);

  const rounds = currentBooking?.rounds ?? [];

  const totalUnknown = rounds.filter(
    (round) => round.player.clientType === "unknownGuest"
  ).length;

  const unknownGuestMaximum =
    capacityOnBooking -
    (rounds.filter(
      (round) =>
        !round.isNonPlayingHost && round.player.clientType !== "unknownGuest"
    )?.length ?? 0);

  const onIncrement = () => {
    if (onAddUnknownGuest && totalUnknown < unknownGuestMaximum) {
      onAddUnknownGuest();
    }
  };

  const onDecrement = () => {
    if (onRemoveUnknownGuest && totalUnknown > 0) {
      onRemoveUnknownGuest();
    }
  };
  return membersCanAddUnknownGuests ? (
    <HStack
      justifyContent="space-between"
      alignItems="center"
      px={6}
      py={2}
      my={2}
      opacity={totalUnknown >= unknownGuestMaximum ? 0.5 : 1}
    >
      <HStack alignItems="center" gap={4}>
        <Avatar type="guest" size="sm" useIcon />
        <Text
          maxFontSizeMultiplier={2}
          variant="mainBaseMedium"
        >{t`Unknown Guest`}</Text>
      </HStack>
      <Crementor
        testID="unknown-guest-crementor"
        min={0}
        max={unknownGuestMaximum}
        value={totalUnknown}
        onIncrement={onIncrement}
        onDecrement={onDecrement}
      />
    </HStack>
  ) : null;
};
